import React from 'react';
import styles from 'components/quote_builder_widget/settings/_style.module.scss';

// In setup order: what the widget sells, what it asks the customer, then how it looks, then installing it. A tab with subsections opens its first
// one and stays active while any of them is shown.
const SECTIONS = [
  { id: 'configuration', label: 'quote_builder_widget.section_configuration', icon: 'fa-cog', subsections: ['configuration_domains', 'configuration_unit', 'configuration_language'] },
  { id: 'materials', label: 'quote_builder_widget.section_materials', icon: 'fa-cubes', subsections: ['carton_materials', 'corrugated_materials'] },
  { id: 'printing', label: 'quote_builder_widget.section_printing', icon: 'fa-print', subsections: ['printing_machines'] },
  { id: 'cutting', label: 'quote_builder_widget.section_cutting', icon: 'fa-scissors', subsections: ['cutting_machines'] },
  { id: 'hot_stamping', label: 'quote_builder_widget.section_hot_stamping', icon: 'fa-star', subsections: ['hot_stamping_materials', 'hot_stamping_machines', 'hot_stamping_printing_block'] },
  { id: 'customer', label: 'quote_builder_widget.section_customer', icon: 'fa-user', subsections: ['customer_contact', 'customer_two_factor'] },
  { id: 'appearance', label: 'quote_builder_widget.section_appearance', icon: 'fa-paint-brush', subsections: ['appearance_theme', 'appearance_colors', 'appearance_font', 'appearance_custom_css'] },
  { id: 'product_images', label: 'quote_builder_widget.section_product_images', icon: 'fa-picture-o', subsections: ['product_images_by_catalog_name'] },
  { id: 'installation', label: 'quote_builder_widget.section_installation', icon: 'fa-code', subsections: ['installation_catalog_name', 'installation_code', 'installation_domains', 'installation_developer'] },
];

export const tabIdFor = (activeSection) => {
  const section = SECTIONS.find((candidate) => candidate.id === activeSection || candidate.subsections.includes(activeSection));
  return section ? section.id : activeSection;
};

const firstSectionOf = (section) => section.subsections[0] || section.id;

export const sectionToShow = (requested) => {
  const tab = SECTIONS.find((section) => section.id === requested);
  if (tab) {
    return firstSectionOf(tab);
  }
  return SECTIONS.some((section) => section.subsections.includes(requested)) ? requested : undefined;
};

const SettingsTabs = ({ activeSection, onSectionChange }) => {
  const activeTabId = tabIdFor(activeSection);
  const sectionToOpen = (section) => (section.id === activeTabId ? activeSection : firstSectionOf(section));

  const handleKeyDown = (event, sectionIndex) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onSectionChange(sectionToOpen(SECTIONS[sectionIndex]));
    } else if (event.key === 'ArrowRight') {
      event.preventDefault();
      const nextIndex = (sectionIndex + 1) % SECTIONS.length;
      onSectionChange(firstSectionOf(SECTIONS[nextIndex]));
      document.getElementById(`tab-${SECTIONS[nextIndex].id}`)?.focus();
    } else if (event.key === 'ArrowLeft') {
      event.preventDefault();
      const previousIndex = (sectionIndex - 1 + SECTIONS.length) % SECTIONS.length;
      onSectionChange(firstSectionOf(SECTIONS[previousIndex]));
      document.getElementById(`tab-${SECTIONS[previousIndex].id}`)?.focus();
    }
  };

  return (
    <div className={`dct-tabs ${styles.tabBar}`} role="tablist">
      {SECTIONS.map((section, index) => (
        <div
          key={section.id}
          id={`tab-${section.id}`}
          className={activeTabId === section.id ? 'dct-tab is-active' : 'dct-tab'}
          onClick={() => onSectionChange(sectionToOpen(section))}
          role="tab"
          tabIndex={activeTabId === section.id ? 0 : -1}
          aria-selected={activeTabId === section.id}
          aria-controls={`tabpanel-${section.id}`}
          onKeyDown={(event) => handleKeyDown(event, index)}
        >
          {section.icon && <i className={`fa ${section.icon} ${styles.tabIcon}`} aria-hidden="true"></i>}
          <span>{t(section.label)}</span>
        </div>
      ))}
    </div>
  );
};

export default SettingsTabs;
